












import gql from 'graphql-tag';
import { defineComponent, reactive, ref } from '@vue/composition-api';

import { useMutation } from '@vue/apollo-composable';
import { client, onLogin } from '@/vue-apollo';

import { useRouter } from 'vivat';

const Login = defineComponent({
  setup() {
    const modal = ref(null);

    const loginFormInput = reactive({
      username: '',
      password: '',
    });

    const loginMutation = useMutation(gql`
      mutation login($username: String!, $password: String!) {
        login(username: $username, password: $password) {
          token
          success
          expiresIn
        }
      }
    `, {
      variables: loginFormInput,
    });

    const { router } = useRouter();

    loginMutation.onDone(async (result) => {
      if ((result as any).data.login.success) {
        await onLogin(client, (result as any).data.login.token);
        router.push({
          name: 'Dashboard',
        });
      } else {
        (modal.value as any).open();
      }
    });

    return {
      modal,
      loginFormInput,
      loginMutation,
    };
  },
});

export default Login;
